import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {DATA_TYPE_JSX} from "typeConstants/dataTypes";

import MCard from "components/Shared/MCard.tsx";
import WebConfig from "middlewares/WebConfig";
class DataComparison extends Component {
  constructor(props) {
    super(props);
    this.getPhoto = this.getPhoto.bind(this);
    this.getFields = this.getFields.bind(this);
    this.checkPhotoTag = this.checkPhotoTag.bind(this);
  }

  getPhoto() {
    const { photos } = this.props;
    // if photos exist, map through photos and return photos with appropriate tags 
    if (photos) {
      let photoWithTag = photos.map(photo => {
        if (photo.Tags.some(this.checkPhotoTag)) {
          return photo;
        }
      });
      photoWithTag = photoWithTag.filter(elem => elem !== undefined); 
      return this.getFields(photoWithTag);
    }
  }

  getFields(photo = []) {
    const {propertyAddress, token} = this.props;
    let fields = [];
    if (photo.length === 0) {
      fields.push({
        key: "propertyPhoto",
        value: "Not Found",
        label: "Property Photo"
      });
    } else {
      fields.push({
        key: photo[0].photoID,
        value: <img src={`${WebConfig.photoService}/${photo[0].BucketUri}/${photo[0].Id}?SSO=${token}`} alt="property photo" className="qa-photo" />,
        label: "Property Photo",
        dataType: DATA_TYPE_JSX,
      });
    }
    fields.push({
      key: "propertyAddress",
      value: propertyAddress.address,
      label: "Property Address"
    });
    return fields;
    }
    
  checkPhotoTag(tag) {
    const lowerCaseTag = tag.toLowerCase();
    if (lowerCaseTag === "address" || lowerCaseTag === "address number" || lowerCaseTag === "address photo" || lowerCaseTag === "address verification") {
      return tag;
    }
  }

  render() {
    return ( <MCard title="Data Comparison" fields={this.getPhoto()} />);
  }
}

DataComparison.propTypes ={
  controlNumber: PropTypes.number.isRequired,
  propertyAddress: PropTypes.object.isRequired,
  photos: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  token: state.user.profile.token,
});

export default connect(mapStateToProps, null)(DataComparison);